module.exports = "../images/fishing-trip.jpg?v=ff0fa8c";